(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PublicSiteLanguageRelationshipSearch', PublicSiteLanguageRelationshipSearch);

    PublicSiteLanguageRelationshipSearch.$inject = ['$resource'];

    function PublicSiteLanguageRelationshipSearch($resource) {
        var resourceUrl =  'api/_search/public-site-language-relationships/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
